import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import {
  Button,
  ButtonGroup,
  ButtonToolbar,
  Clearfix,
  Glyphicon,
  Col,
  Row,
} from 'react-bootstrap';


import SplitLayout from '../../../layouts/SplitLayout';

import TicketAttachmentsTableModal, {
  attachmentsModalPropTypes,
  withAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentsTableModal';
import TicketAttachmentUploadModal, {
  uploadAttachmentsModalPropTypes,
  withUploadAttachmentsModalState,
} from '../../tickets/attachments/TicketAttachmentUploadModal';

import TicketUploadSubmissionModal, {
  uploadSubmissionItemModalPropTypes,
  withUploadSubmissionItemModalState,
} from '../../tickets/attachments/TicketUploadSubmissionModal';
import TicketFacts from '../../tickets/components/TicketFacts';
import TicketUserHourSummary from '../../tickets/components/TicketUserHourSummary';
import TicketSubmissionItemDownloadButton from '../../tickets/components/TicketSubmissionItemDownloadButton';
import TicketSubmissionItemViewer from '../../tickets/components/TicketSubmissionItemViewer';
import TicketVariablesEditor from '../../tickets/components/TicketVariablesEditor';
import JobFacts from '../../tickets/components/JobFacts';
import TicketCaluclatedFields from '../../tickets/components/TicketCalculatedFields';

import { undeferJobByTicketId } from '../actions';
import { getIsDeferredJobView } from '../selectors';

const propTypes = exact({
  ticketId: PropTypes.number.isRequired,
  undeferJobByTicketIdAction: PropTypes.func.isRequired,
  jobId: PropTypes.number,
  isDeferredJobView: PropTypes.bool.isRequired,

  ...attachmentsModalPropTypes,
  ...uploadAttachmentsModalPropTypes,
  ...uploadSubmissionItemModalPropTypes,
});


const TicketReview = (props) => {
  const { ticketId } = props;

  const {
    showSubmissionItemModal, closeUploadSubmissionItemModal, openUploadSubmissionItemModal,
  } = props;

  const {
    showViewAttachmentsModal, closeViewAttachmentsModal, openViewAttachmentsModal,
  } = props;

  const {
    showUploadAttachmentsModal, closeUploadAttachmentsModal, openUploadAttachmentsModal,
  } = props;

  const {
    undeferJobByTicketIdAction, jobId, isDeferredJobView,
  } = props;

  const handleUndeferJob = () => {
    undeferJobByTicketIdAction(ticketId, jobId);
  };

  const leftSplit = () => {
    return (
      <div>
        <TicketSubmissionItemViewer ticketId={ticketId} />
      </div>
    );
  };

  const rightSplit = () => {
    return (
      <div>
        <div className="panel panel-default">
          <TicketFacts ticketId={ticketId} />
        </div>
        <div className="panel panel-default">
          <TicketUserHourSummary ticketId={ticketId} />
        </div>
        <Row>
          <Col md={7}>
            <div className="panel panel-default">
              <div className="panel-body">
                <TicketVariablesEditor ticketId={ticketId} />
              </div>
            </div>
          </Col>
          <Col md={5}>
            <div className="panel panel-default">
              <div className="panel-body">
                <TicketCaluclatedFields ticketId={ticketId} />
              </div>
            </div>
          </Col>
        </Row>
        <div className="panel panel-default">
          <JobFacts ticketId={ticketId} />
        </div>
      </div>
    );
  };

  return (
    <div className="panel-body">
      <div className="panel panel-default">
        <div className="panel-body">
          <SplitLayout
            leftSize={6}
            leftRender={leftSplit}
            rightSize={6}
            rightRender={rightSplit}
          />
        </div>
        <div className="panel-footer">
          <Clearfix>
            <ButtonToolbar className="pull-left">
              <TicketSubmissionItemDownloadButton ticketId={ticketId} />
              <ButtonGroup>
                <Button onClick={openUploadSubmissionItemModal}>
                  Replace Ticket
                </Button>
                <Button onClick={openViewAttachmentsModal}>
                  View Attachments
                </Button>
                <Button onClick={openUploadAttachmentsModal}>
                  Upload Attachment
                </Button>
              </ButtonGroup>
            </ButtonToolbar>
            {isDeferredJobView && (
              <ButtonToolbar className="pull-right">
                <Button bsStyle="danger" onClick={handleUndeferJob}>
                  <Glyphicon glyph="remove" style={{ marginRight: '0.5em' }} />
                  Undefer
                </Button>
              </ButtonToolbar>
            )}
          </Clearfix>
        </div>
        <div>
          <TicketUploadSubmissionModal
            onHide={closeUploadSubmissionItemModal}
            show={showSubmissionItemModal}
            ticketId={ticketId}
          />
          <TicketAttachmentsTableModal
            show={showViewAttachmentsModal}
            onHide={closeViewAttachmentsModal}
            ticketId={ticketId}
          />
          <TicketAttachmentUploadModal
            show={showUploadAttachmentsModal}
            onHide={closeUploadAttachmentsModal}
            ticketId={ticketId}
          />
        </div>
      </div>
    </div>
  );
};


const mapStateToProps = (state) => {
  return {
    jobId: state.ticketInvoicing.jobId,
    isDeferredJobView: getIsDeferredJobView(state),
  };
};


const mapDispatchToProps = {
  undeferJobByTicketIdAction: undeferJobByTicketId,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

TicketReview.propTypes = propTypes;


const enhance = compose(
  withAttachmentsModalState,
  withUploadAttachmentsModalState,
  withUploadSubmissionItemModalState,
  withRedux,
);

export default enhance(TicketReview);
